import React, { useEffect, useRef } from 'react';
import { ScrollDirections } from './Props.types';
import { useScrollContext } from './ScrollContext';
const scrollHandlerStateInitialState = {
    currentChildIndex: 0,
    scrollState: {
        YDirection: 'stationary',
        XDirection: 'stationary',
    },
    childs: [],
    pagesContainer: null,
    direction: ScrollDirections.vertical,
    scrollEnabled: false,
    animationDuration: 400,
    isRoot: false,
};
export default function ScrollingSection({ children, scrollEnabled = false, animationDuration = 400, animationEasing = 'cubic-bezier(0.76, 0, 0.24, 1)', direction = ScrollDirections.vertical, isRoot = false, width = '100vw', height = '100vh', onScrollStart = () => { }, onScrollInit = () => { }, onScrollCommandCede = () => { }, onScrollEnd = () => { }, }) {
    const scrollStateRef = useRef(Object.assign(Object.assign({}, scrollHandlerStateInitialState), { direction,
        scrollEnabled,
        animationDuration,
        isRoot,
        onScrollStart,
        onScrollEnd,
        onScrollInit,
        onScrollCommandCede }));
    const scrollContainerRef = useRef(null);
    const scrollSubscribed = useRef(false);
    const { scrollManager, scrollContext } = useScrollContext();
    useEffect(() => {
        if (scrollManager && !scrollSubscribed.current) {
            const containerRef = scrollContainerRef.current;
            let scrollState = scrollStateRef.current;
            if (containerRef) {
                const pagesContainerAsNodes = containerRef.childNodes[0];
                const pagesContainer = pagesContainerAsNodes;
                const childsAsNodes = pagesContainer.childNodes;
                const childs = childsAsNodes;
                scrollState = Object.assign(Object.assign({}, scrollState), { pagesContainer,
                    childs });
                scrollManager.subscribe(scrollContainerRef.current, scrollState);
                scrollSubscribed.current = true;
            }
        }
    }, [scrollManager, isRoot]);
    if (!scrollContext && !isRoot) {
        throw new Error('Only use <NestedPageScroll> inside <PageScroll>');
    }
    return (React.createElement("div", { style: {
            width,
            height,
            overflow: 'hidden',
            position: 'relative',
        } },
        React.createElement("div", { ref: scrollContainerRef, style: {
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                position: 'absolute',
            } },
            React.createElement("div", { style: {
                    transition: `transform ${animationDuration}ms ${animationEasing}`,
                }, className: (direction === 'vertical' ? 'flex-col' : 'flex') + ' scroll-container' }, children))));
}
